import { gql } from "@/__generated__/gql";

export const RISE_COMMIT_SCORE_TIME_SERIES = gql(`
  query riseCommitScoreTimeSeries($orgId: ID!, $userId: ID!) {
    node(id: $userId) {
      id
      ... on Student {
        __typename
        rise {
          commitScoreTimeSeries(organizationId: $orgId) {
            date
            value
            index
          }
        }
      }
    }
  }
`);
